{
  "nav": {
    "home": "Community Home",
    "articles": "News & Articles",
    "events": "Card Shows",
    "dealers": "Dealer Directory"
  },
  "layout": {
    "breadcrumbHome": "Home",
    "breadcrumbCommunity": "Community",
    "eyebrow": "Community Hub",
    "title": "News, Shows & UK Dealers",
    "subtitle": "Everything happening around the UK trading card scene — curated by BidNova."
  },
  "home": {
    "tiles": {
      "articlesTitle": "News & Articles",
      "articlesDesc": "Market insights & buying guides",
      "eventsTitle": "UK Card Shows",
      "eventsDesc": "Upcoming events & tournaments",
      "dealersTitle": "Dealer Directory",
      "dealersDesc": "Trusted UK card shops",
      "explore": "Explore"
    },
    "articlesEyebrow": "Market insights, buying guides and community stories",
    "articlesTitle": "Latest News & Guides",
    "eventsEyebrow": "Trade nights, tournaments and grading meetups",
    "eventsTitle": "Upcoming UK Card Shows",
    "dealersEyebrow": "Trusted UK card shops, hobby stores and online retailers",
    "dealersTitle": "Featured Dealers",
    "viewAll": "View all →",
    "readMore": "Read more",
    "emptyArticles": "Articles are coming soon.",
    "emptyEvents": "No upcoming events yet — check back soon.",
    "emptyDealers": "Dealer directory is coming soon."
  },
  "articles": {
    "index": {
      "title": "News & Articles",
      "subtitle": "Market insights, buying guides and stories from the UK card community.",
      "searchPlaceholder": "Search articles…",
      "searchLabel": "Search articles",
      "all": "All",
      "empty": "No articles match your filters yet.",
      "readMore": "Read more",
      "authorFallback": "BidNova"
    },
    "detail": {
      "authorFallback": "BidNova Team",
      "backLink": "Back to all articles"
    }
  },
  "events": {
    "communityIndex": {
      "title": "UK Card Show Calendar",
      "subtitle": "Trading card shows, tournaments, trade nights, grading submission events and collector meetups across the UK.",
      "empty": "No upcoming events yet — check back soon."
    },
    "publicIndex": {
      "eyebrow": "Community",
      "title": "Upcoming Card Shows & Events",
      "subtitle": "Trading card shows, tournaments, trade nights, grading submission events and collector meetups happening across the UK.",
      "empty": "No upcoming events yet — check back soon."
    },
    "card": {
      "featured": "Featured",
      "viewDetails": "View details"
    },
    "detail": {
      "recurring": "Recurring",
      "days": "Days",
      "hours": "Hours",
      "minutes": "Minutes",
      "when": "When",
      "where": "Where",
      "openInMaps": "Open in Maps",
      "rsvp": "RSVP",
      "getTickets": "Get Tickets",
      "visitWebsite": "Visit Website",
      "organisedBy": "Organised by {name}"
    },
    "section": {
      "eyebrow": "Community",
      "title": "Upcoming Card Shows",
      "viewAll": "All events →"
    }
  },
  "dealers": {
    "index": {
      "title": "Dealer Directory",
      "subtitle": "Trusted UK card shops, hobby stores, grading services and online retailers.",
      "searchPlaceholder": "Search by name, town or postcode…",
      "searchLabel": "Search dealers",
      "typeLabel": "Type",
      "gameLabel": "Game",
      "all": "All",
      "empty": "No dealers match your filters yet.",
      "featured": "Featured",
      "visitWebsite": "Visit website"
    },
    "detail": {
      "featured": "Featured",
      "contact": "Contact",
      "website": "Website",
      "openingHours": "Opening Hours",
      "backLink": "Back to directory"
    }
  },
  "updates": {
    "eyebrow": "Community",
    "title": "Latest Community Updates",
    "featured": "Featured",
    "readMore": "Read more",
    "communityUpdateAlt": "BidNova community update"
  },
  "partners": {
    "index": {
      "eyebrow": "Partner Directory",
      "title": "Trusted BidNova partners",
      "subtitle": "Every partner below is reviewed and approved by the BidNova team — from card shops and grading companies to shipping and insurance specialists.",
      "becomePartner": "Become a partner →",
      "searchPlaceholder": "Search partners by name, description or location…",
      "searchLabel": "Search partners",
      "verifiedOnly": "Verified only",
      "resultsCount": "{count, plural, one {# result} other {# results}}",
      "all": "All",
      "loading": "Loading partners…",
      "empty": "No partners match your filters yet."
    },
    "detail": {
      "loading": "Loading…",
      "unavailable": "Partner unavailable.",
      "notFound": "Partner not found.",
      "website": "Website",
      "partnerSince": "Partner since {year}",
      "contact": "Contact",
      "active": "Active",
      "sold": "Sold",
      "since": "Since",
      "about": "About",
      "shipping": "Shipping & Delivery",
      "policies": "Policies",
      "bidnovaShop": "BidNova Shop",
      "alsoSells": "This partner also sells on BidNova.",
      "visitShop": "Visit shop",
      "social": "Social"
    },
    "apply": {
      "eyebrow": "Become a Partner",
      "title": "Grow your business with BidNova",
      "subtitle": "Official Partners, Featured Shops, grading companies and accessories brands — apply to join the BidNova ecosystem. All placements are currently free and curated by our team."
    }
  },
  "shops": {
    "index": {
      "eyebrow": "Featured Shops",
      "title": "Trusted BidNova sellers",
      "subtitle": "Every shop below has been reviewed and approved by the BidNova team.",
      "directoryTitle": "All Featured Shops",
      "directoryEyebrow": "Directory"
    },
    "detail": {
      "unavailable": "Shop unavailable.",
      "notFound": "Shop not found.",
      "fullProfile": "Full profile",
      "liveAuctions": "Live auctions",
      "noAuctions": "No live auctions from this shop right now.",
      "sales": "{count, plural, one {# sale} other {# sales}}"
    }
  },
  "advertise": {
    "eyebrow": "Partner Programme",
    "title": "Advertise on BidNova",
    "subtitlePrefix": "Get in front of the UK's most engaged trading card community. During our launch phase, all advertising placements are ",
    "subtitleHighlight": "complimentary",
    "subtitleSuffix": " and curated by the BidNova team.",
    "freeBadge": "Free during launch · No credit card required",
    "mostPopular": "Most popular",
    "applyNow": "Apply now",
    "disclaimer": "Placements are reviewed manually by our team and clearly labelled as “Sponsored”. BidNova does not guarantee specific views, clicks or sales outcomes.",
    "faqTitle": "Frequently asked",
    "ctaTitle": "Prefer to talk it through?",
    "ctaSubtitle": "Tell us about your business and we'll come back with a tailored proposal.",
    "ctaButton": "Start an application",
    "placements": {
      "banner": {
        "name": "Homepage Sponsored Banner",
        "tagline": "Premium hero placement in front of every visitor.",
        "b1": "Above-the-fold placement on the homepage",
        "b2": "Clearly labelled as Sponsored",
        "b3": "Transparent impression & click reporting",
        "b4": "Rotates with a small curated set of partners"
      },
      "featuredShop": {
        "name": "Featured Shop",
        "tagline": "Get your shop highlighted to serious collectors.",
        "b1": "Featured Shops grid on the homepage",
        "b2": "Direct link to your BidNova seller profile",
        "b3": "Verified badge on your public profile",
        "b4": "Priority placement in category pages"
      },
      "officialPartner": {
        "name": "Official Partner",
        "tagline": "Join the BidNova Official Partner Network.",
        "b1": "Logo in the Official Partners carousel",
        "b2": "Dedicated public partner profile page",
        "b3": "Cross-promotion in newsletters & socials",
        "b4": "Long-term brand association with BidNova"
      },
      "eventSponsorship": {
        "name": "Event & Custom Sponsorship",
        "tagline": "Bespoke campaigns and event tie-ins.",
        "b1": "Tournament, event and prize sponsorships",
        "b2": "Custom homepage takeovers",
        "b3": "Integrated editorial features",
        "b4": "Tailored to your brand & audience"
      }
    },
    "faqs": {
      "q1": {
        "q": "How much does it cost?",
        "a": "Advertising placements on BidNova are currently free while we grow the partner network. Our team will let you know well in advance if that ever changes."
      },
      "q2": {
        "q": "Where will my advert appear?",
        "a": "Placements include the homepage sponsored slot, the Featured Shops grid, the Official Partners carousel, or a bespoke campaign agreed with our team."
      },
      "q3": {
        "q": "How do you count impressions and clicks?",
        "a": "Impressions are counted only when the placement enters the visible viewport, and clicks are recorded server-side with duplicate protection. No personal identifiers are stored."
      },
      "q4": {
        "q": "Do you offer bespoke sponsorship?",
        "a": "Yes — event sponsorships, custom homepage takeovers and integrated campaigns are all available. Mention your idea in the application form."
      }
    },
    "apply": {
      "eyebrow": "Advertise with BidNova",
      "title": "Sponsor the UK's premium card marketplace",
      "subtitle": "Tell us about your business and how you'd like to reach BidNova's collector community. Placements are curated by our team — no credit card required."
    }
  },
  "featuredShops": {
    "eyebrow": "Curated sellers",
    "title": "Featured Shops",
    "browseAll": "Browse all shops →",
    "live": "Live",
    "sold": "Sold",
    "rating": "Rating",
    "newSeller": "New Seller",
    "new": "New",
    "sales": "Sales",
    "visitShop": "Visit Shop",
    "viewShop": "View Shop",
    "noneInCategory": "No shops in this category yet.",
    "all": "All",
    "verifiedAlt": "Verified seller",
    "sellerFallback": "BidNova Seller"
  },
  "partnerCarousel": {
    "eyebrow": "Trusted by the trade",
    "title": "Trusted Partners",
    "verifiedAlt": "Verified",
    "officialPartnerSuffix": " — Official Partner"
  },
  "becomePartnerCta": {
    "eyebrow": "Partner Network",
    "headlineDefault": "Grow your business with BidNova Auctions",
    "descriptionDefault": "Advertise your business, become a Featured Shop or join the BidNova Official Partner Network.",
    "becomePartner": "Become a Partner",
    "advertiseWithUs": "Advertise With Us",
    "closed": "Applications are temporarily closed. Please check back soon."
  },
  "newsletter": {
    "eyebrow": "Newsletter",
    "title": "Join the BidNova Community",
    "subtitle": "Stay updated with new auctions, featured cards, partner promotions, card shows and marketplace news.",
    "emailPlaceholder": "you@example.com",
    "emailLabel": "Email address",
    "subscribe": "Subscribe",
    "subscribing": "Subscribing…",
    "consentLabel": "I agree to receive BidNova emails",
    "consentPrefix": "I agree to receive BidNova Auctions marketing emails. I can unsubscribe at any time. See our ",
    "privacyLink": "Privacy Policy",
    "consentError": "Please tick the consent box to continue.",
    "genericError": "Something went wrong. Please try again.",
    "successTitle": "You're on the list",
    "successBody": "Watch your inbox for BidNova auction highlights and community news."
  },
  "partnerForm": {
    "types": {
      "featuredShop": "Featured Shop",
      "officialPartner": "Official Partner",
      "homepageAdvertising": "Homepage Sponsor",
      "eventSponsor": "Event Partner",
      "gradingCompany": "Grading Company",
      "accessoriesStore": "Accessories Store",
      "custom": "Other"
    },
    "consentRequired": "Please accept the terms to continue.",
    "genericError": "Something went wrong",
    "successTitle": "Application received",
    "successBody": "Thank you for your interest in partnering with BidNova Auctions. Our team will review your submission and be in touch by email.",
    "backToHome": "Back to home",
    "applicationsClosed": "Applications are temporarily closed. You may still fill in the form — submissions will be paused until we reopen.",
    "sectionBusiness": "Business",
    "sectionSocial": "Social",
    "sectionApplication": "Application",
    "sectionBrief": "Advertising brief",
    "fields": {
      "businessName": "Business name *",
      "contactName": "Contact name *",
      "businessEmail": "Business email *",
      "contactPhone": "Contact phone",
      "website": "Website",
      "businessType": "Business type *",
      "country": "Country",
      "instagram": "Instagram",
      "facebook": "Facebook",
      "discord": "Discord",
      "applicationType": "Application type *",
      "existingSeller": "Existing BidNova seller username (optional)",
      "logoUrl": "Logo URL",
      "bannerUrl": "Banner image URL (optional)",
      "requestedPlacement": "Requested placement",
      "noPreference": "No preference",
      "estimatedBudget": "Estimated budget (£)",
      "requestedStart": "Requested start date",
      "requestedEnd": "Requested end date",
      "advertisingGoal": "Advertising goal",
      "advertisingGoalPlaceholder": "What would you like this campaign to achieve?",
      "description": "Description",
      "services": "Services offered",
      "notes": "Notes"
    },
    "consentPrefix": "I agree to the BidNova Auctions ",
    "consentMiddle": " and ",
    "consentSuffix": ", and consent to being contacted about this application.",
    "termsLink": "Terms",
    "privacyLink": "Privacy Policy",
    "submit": "Submit application",
    "submitting": "Submitting…"
  }
}
